import React from 'react';

export default function Dummy(): JSX.Element {
  return (
    <div>Dummy</div>
  );
}
